import produce from 'immer';
import {
  SET_DIALOG,
  SET_PHONE,
} from "src/actions/modalActions";
import { modalState, modalAction } from './types/modalTypes';

const initialState: modalState = {
  modalStatus : {},
  prevModal: [],
  opening: "",
  phoneNumber: "",
  props : {},
}


const modalReducer = (
  state:modalState=initialState,
  action:modalAction
) => {
  switch (action.type) {
    case SET_DIALOG: {
      const { name, status, props } = action.payload;
      return produce(state, (draft) => {
        if (draft.opening) {
          draft.modalStatus[name] = status 
          if (name !== draft.opening) draft.modalStatus[draft.opening] = false;
          draft.prevModal.push(draft.opening);
        } else {
          draft.modalStatus[name] = status 
        }
        if (status) draft.opening = name;
        if (!status) {
          if (name !== draft.opening) draft.prevModal.push(name);
          draft.opening = "";
        }
        if (draft.prevModal.length > 5) draft.prevModal.shift();
        draft.props = props
      });
    }

    case SET_PHONE: {
      const { phoneNumber } = action.payload;
      return produce(state, (draft) => {
        draft.phoneNumber = phoneNumber || draft.phoneNumber;
      });
    }

    default: {
      return state;
    }
  }
};

export default modalReducer;